// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledUiCheckbox = styled('div')(
  () => css`
    .MuiCheckbox-root {
      .MuiSvgIcon-root {
        font-size: 1.669rem;
        fill: #a6a9af;
      }
      &.Mui-checked {
        .MuiSvgIcon-root {
          font-size: 1.669rem;
          fill: #199da3;
        }
      }
      &.Mui-disabled {
        opacity: 0.4;
      }
    }
  `
);
